import { makeStyles } from 'tss-react/mui';

const useStylesIconTextBlock: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  iconTextBlockIcon: {
    '& > span, & > svg': {
      width: 24,
      height: 24,
    },
  },
}));

export default useStylesIconTextBlock;
